(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["happysoy-advent-giveaway"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = root => {
    root.querySelectorAll('[data-hsg-form]').forEach(shell => {
      if (shell.dataset.hsgReady) return;
      shell.dataset.hsgReady = 'true';
      const embed = shell.querySelector('[data-hsg-embed]');
      const loading = shell.querySelector('[data-hsg-loading]');
      const error = shell.querySelector('[data-hsg-error]');
      const rendered = () => !!embed.querySelector('form, input, button');
      let translationQueued = false;
      const localize = () => {
        translationQueued = false;
        const label = shell.dataset.hsgEmailLabel;
        const required = shell.dataset.hsgRequiredMessage;
        embed.querySelectorAll('input[type="email"]').forEach(input => {
          if (input.placeholder === 'Email') input.placeholder = label;
        });
        embed.querySelectorAll('label').forEach(element => {
          if (element.textContent.trim() === 'Email') element.textContent = label;
        });
        const textNodes = document.createTreeWalker(embed, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = textNodes.nextNode())) {
          if (node.nodeValue.trim() === 'This field is required') {
            node.nodeValue = required;
          }
        }
      };
      const translationObserver = new MutationObserver(() => {
        if (translationQueued) return;
        translationQueued = true;
        requestAnimationFrame(localize);
      });
      translationObserver.observe(embed, {childList:true, subtree:true, characterData:true});
      localize();
      let timeout;
      const observer = new MutationObserver(() => {
        if (!rendered()) return;
        loading.hidden = true;
        error.hidden = true;
        clearTimeout(timeout);
        observer.disconnect();
      });
      observer.observe(embed, {childList:true, subtree:true});
      if (rendered()) { loading.hidden = true; observer.disconnect(); }
      else timeout = setTimeout(() => { loading.hidden = true; error.hidden = false; }, 15000);
      window.addEventListener('pagehide', () => {observer.disconnect();translationObserver.disconnect();clearTimeout(timeout);}, {once:true});
    });
  };
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
(() => {
  if (!document.body.classList.contains('hsg-page')) return;
  const closing = new WeakSet();
  let queued = false;
  const closeOtherPopup = () => {
    queued = false;
    document.querySelectorAll('form[data-testid="klaviyo-form-QVdBds"]').forEach(form => {
      const dialog = form.closest('[role="dialog"][aria-label="POPUP Form"]');
      if (!dialog || dialog.style.display === 'none' || closing.has(dialog)) return;
      const close = dialog.querySelector('button.klaviyo-close-form[aria-label="Close dialog"]');
      if (!close) return;
      closing.add(dialog);
      close.click();
      requestAnimationFrame(() => closing.delete(dialog));
    });
  };
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(closeOtherPopup);
  });
  observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['style']});
  closeOtherPopup();
  window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["happysoy-adventskalender"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('happysoy-advent')) {
    customElements.define('happysoy-advent', class extends HTMLElement {
      connectedCallback() {
        if (this.hsaController) return;
        this.hsaController = new AbortController();
        const signal = this.hsaController.signal;
        this.setupGallery(signal);
        this.setupScentExplorer(signal);
        this.setupReviewCarousel(signal);
        this.setupClickVideo(signal);
        const fields = Array.from(this.querySelectorAll('[data-hsa-qty]'));
        const links = Array.from(this.querySelectorAll('[data-hsa-checkout]'));
        const minus = Array.from(this.querySelectorAll('[data-hsa-minus]'));
        const plus = Array.from(this.querySelectorAll('[data-hsa-plus]'));
        const minimum = Number(this.dataset.qtyMin) || 1;
        const increment = Number(this.dataset.qtyStep) || 1;
        const rawMaximum = Number(this.dataset.qtyMax) || minimum;
        const maximum = minimum + Math.floor((rawMaximum - minimum) / increment) * increment;
        const available = this.dataset.available === 'true' && Boolean(this.dataset.variant);
        const status = this.querySelector('[data-hsa-quantity-status]');
        const stickyQuantity = this.querySelector('[data-hsa-sticky-quantity]');
        const stickyCount = this.querySelector('[data-hsa-sticky-count]');
        let quantity = minimum;
        const normalize = value => {
          const number = Number(value);
          const bounded = Math.min(maximum, Math.max(minimum, Number.isFinite(number) ? Math.floor(number) : minimum));
          return minimum + Math.floor((bounded - minimum) / increment) * increment;
        };
        const sync = (value, announce = false) => {
          quantity = normalize(value);
          fields.forEach(field => { field.value = String(quantity); });
          links.forEach(link => { link.form.elements.quantity.value = String(quantity); });
          minus.forEach(button => { button.disabled = !available || quantity <= minimum; });
          plus.forEach(button => { button.disabled = !available || quantity >= maximum; });
          if (stickyQuantity) stickyQuantity.textContent = ' – ' + quantity + ' Kalender';
          if (stickyCount) { stickyCount.hidden = quantity === 1; stickyCount.textContent = quantity + ' × '; }
          if (announce && status) status.textContent = 'Menge: ' + quantity + '. Für alle Kaufbuttons übernommen.';
        };
        minus.forEach(button => button.addEventListener('click', () => sync(quantity - increment, true), { signal }));
        plus.forEach(button => button.addEventListener('click', () => sync(quantity + increment, true), { signal }));
        fields.forEach(field => {
          field.addEventListener('input', () => {
            if (field.value === '') return;
            sync(field.value);
          }, { signal });
          field.addEventListener('change', () => sync(field.value, true), { signal });
          field.addEventListener('blur', () => sync(field.value), { signal });
        });
        links.forEach(link => link.addEventListener('click', event => {
          if (!available) { event.preventDefault(); return; }
          sync(quantity);
        }, { signal }));
        sync(fields[0] ? fields[0].value : minimum);
        const sticky = this.querySelector('[data-hsa-sticky]');
        const boxes = Array.from(this.querySelectorAll('[data-hsa-buybox]'));
        const firstBox = boxes[0];
        if (!sticky || !firstBox) return;
        const updateSticky = () => {
          this.hsaFrame = null;
          const viewportHeight = window.innerHeight;
          const anyBoxVisible = boxes.some(box => {
            const rect = box.getBoundingClientRect();
            return rect.bottom > 90 && rect.top < viewportHeight;
          });
          const firstBoxPassed = firstBox.getBoundingClientRect().bottom <= 90;
          const stickyFocused = sticky.contains(document.activeElement);
          const shouldShow = available && firstBoxPassed && !anyBoxVisible;
          if (!stickyFocused || shouldShow) sticky.hidden = !shouldShow;
        };
        const queueSticky = () => {
          if (this.hsaFrame == null) this.hsaFrame = requestAnimationFrame(updateSticky);
        };
        window.addEventListener('scroll', queueSticky, { passive: true, signal });
        window.addEventListener('resize', queueSticky, { passive: true, signal });
        sticky.addEventListener('focusout', queueSticky, { signal });
        if ('ResizeObserver' in window) {
          this.hsaResize = new ResizeObserver(queueSticky);
          this.hsaResize.observe(this);
        }
        updateSticky();
      }
      setupClickVideo(signal) {
        this.querySelectorAll('[data-hsa-click-video]').forEach(shell => {
          const button = shell.querySelector('[data-hsa-video-launch]');
          const template = shell.querySelector('[data-hsa-video-template]');
          if (!button || !template || shell.querySelector('video')) return;
          button.hidden = false;
          button.addEventListener('click', () => {
            if (shell.querySelector('video')) return;
            const fragment = template.content.cloneNode(true);
            const video = fragment.querySelector('video');
            if (!video) return;
            button.hidden = true;
            shell.appendChild(fragment);
            video.tabIndex = 0;
            video.focus({ preventScroll: true });
            video.addEventListener('error', () => {
              video.remove();
              button.hidden = false;
              button.focus({ preventScroll: true });
            }, { once: true, signal });
            const playback = video.play();
            if (playback) playback.catch(() => { video.controls = true; });
          }, { signal });
        });
      }
      setupReviewCarousel(signal) {
        const carousel = this.querySelector('[data-hsa-review-carousel]');
        if (!carousel) return;
        const track = carousel.querySelector('[data-hsa-review-track]');
        const previous = carousel.querySelector('[data-hsa-review-prev]');
        const next = carousel.querySelector('[data-hsa-review-next]');
        const cards = Array.from(track.children);
        const update = () => {
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        };
        let target = track.scrollLeft;
        const move = direction => {
          const step = cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
          target = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, target + direction * step));
          track.scrollTo({ left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), { signal });
        next.addEventListener('click', () => move(1), { signal });
        track.addEventListener('scroll', update, { passive: true, signal });
        track.addEventListener('scrollend', () => { target = track.scrollLeft; }, { signal });
        track.addEventListener('pointerdown', () => { target = track.scrollLeft; }, { passive: true, signal });
        track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            target = track.scrollLeft;
            move(event.key === 'ArrowRight' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            target = event.key === 'Home' ? 0 : track.scrollWidth - track.clientWidth;
            track.scrollTo({ left: target, behavior: 'auto' });
          }
        }, { signal });
        if ('ResizeObserver' in window) {
          this.hsaReviewResize = new ResizeObserver(() => { target = track.scrollLeft; update(); });
          this.hsaReviewResize.observe(track);
        }
        carousel.querySelector('[data-hsa-review-controls]').hidden = false;
        update();
      }
      setupScentExplorer(signal) {
        const explorer = this.querySelector('[data-hsa-scent-explorer]');
        if (!explorer) return;
        const tiles = Array.from(explorer.querySelectorAll('[data-hsa-scent-tile]'));
        const toggle = explorer.querySelector('[data-hsa-scents-toggle]');
        const toolbar = explorer.querySelector('[data-hsa-scent-toolbar]');
        if (!tiles.length || !toggle || !toolbar) return;
        const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
        const states = tiles.map(tile => ({ tile, pinned: tile.getAttribute('aria-pressed') === 'true', hovered: false, suppressed: false }));
        const reflect = (state, instant = false) => {
          state.tile.dataset.instant = String(instant);
          state.tile.dataset.revealed = String(state.pinned || (state.hovered && !state.suppressed));
          state.tile.setAttribute('aria-pressed', String(state.pinned));
        };
        const reflectToggle = () => {
          toggle.textContent = states.every(state => state.pinned) ? toggle.dataset.hideLabel : toggle.dataset.showLabel;
        };
        states.forEach(state => {
          state.tile.disabled = false;
          reflect(state, true);
          state.tile.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'mouse' || !hover.matches) return;
            state.hovered = true;
            reflect(state);
          }, { signal });
          state.tile.addEventListener('pointerleave', () => {
            state.hovered = false;
            state.suppressed = false;
            reflect(state);
          }, { signal });
          state.tile.addEventListener('click', event => {
            state.pinned = !state.pinned;
            state.suppressed = !state.pinned && state.hovered;
            reflect(state, event.detail === 0);
            reflectToggle();
          }, { signal });
        });
        toggle.addEventListener('click', event => {
          const reveal = !states.every(state => state.pinned);
          states.forEach(state => {
            state.pinned = reveal;
            state.suppressed = !reveal && state.hovered;
            reflect(state, event.detail === 0);
          });
          reflectToggle();
        }, { signal });
        hover.addEventListener('change', () => {
          states.forEach(state => {
            state.hovered = false;
            state.suppressed = false;
            reflect(state, true);
          });
        }, { signal });
        explorer.dataset.hsaScentReady = 'true';
        toolbar.hidden = false;
        toggle.hidden = false;
        reflectToggle();
      }
      setupGallery(signal) {
        const gallery = this.querySelector('[data-hsa-gallery]');
        if (!gallery) return;
        const track = gallery.querySelector('[data-hsa-gallery-track]');
        const slides = Array.from(gallery.querySelectorAll('[data-hsa-gallery-slide]'));
        const thumbs = Array.from(gallery.querySelectorAll('[data-hsa-gallery-thumb]'));
        const thumbTrack = gallery.querySelector('[data-hsa-gallery-thumbs]');
        const previous = gallery.querySelector('[data-hsa-gallery-prev]');
        const next = gallery.querySelector('[data-hsa-gallery-next]');
        const counter = gallery.querySelector('[data-hsa-gallery-count]');
        const liveStatus = gallery.querySelector('[data-hsa-gallery-status]');
        if (!track || slides.length < 2) return;
        let current = 0;
        let requested = 0;
        const motion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        const reflect = index => {
          const changed = current !== index;
          current = index;
          previous.disabled = index === 0;
          next.disabled = index === slides.length - 1;
          thumbs.forEach((thumb, position) => {
            if (position === index) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
          slides.forEach((slide, position) => slide.setAttribute('aria-hidden', String(position !== index)));
          counter.textContent = (index + 1) + ' / ' + slides.length;
          if (changed) {
            liveStatus.textContent = slides[index].getAttribute('aria-label');
            const thumb = thumbs[index];
            const left = thumb.offsetLeft;
            if (left < thumbTrack.scrollLeft || left + thumb.offsetWidth > thumbTrack.scrollLeft + thumbTrack.clientWidth) {
              thumbTrack.scrollTo({left: Math.max(0, left - (thumbTrack.clientWidth - thumb.offsetWidth) / 2), behavior: motion()});
            }
          }
        };
        const goTo = index => {
          requested = Math.max(0, Math.min(slides.length - 1, index));
          track.scrollTo({left: requested * track.clientWidth, behavior: motion()});
        };
        previous.addEventListener('click', () => goTo(requested - 1), {signal});
        next.addEventListener('click', () => goTo(requested + 1), {signal});
        thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => goTo(index), {signal}));
        track.addEventListener('keydown', event => {
          let index;
          if (event.key === 'ArrowRight') index = current + 1;
          else if (event.key === 'ArrowLeft') index = current - 1;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = slides.length - 1;
          else return;
          event.preventDefault();
          goTo(index);
        }, {signal});
        const readPosition = () => {
          this.hsaGalleryFrame = null;
          const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
          reflect(index);
        };
        track.addEventListener('scroll', () => {
          if (this.hsaGalleryFrame == null) this.hsaGalleryFrame = requestAnimationFrame(readPosition);
          clearTimeout(this.hsaGalleryTimer);
          this.hsaGalleryTimer = setTimeout(() => { readPosition(); requested = current; }, 140);
        }, {passive:true, signal});
        track.addEventListener('scrollend', () => { readPosition(); requested = current; }, {signal});
        track.addEventListener('pointerdown', () => { requested = current; }, {passive:true, signal});
        if ('ResizeObserver' in window) {
          this.hsaGalleryResize = new ResizeObserver(() => {
            track.scrollTo({left: current * track.clientWidth, behavior:'auto'});
            requested = current;
          });
          this.hsaGalleryResize.observe(track);
        }
        gallery.querySelector('[data-hsa-gallery-controls]').hidden = false;
        thumbTrack.hidden = false;
        reflect(0);
      }
      disconnectedCallback() {
        if (this.hsaController) this.hsaController.abort();
        if (this.hsaResize) this.hsaResize.disconnect();
        if (this.hsaGalleryResize) this.hsaGalleryResize.disconnect();
        if (this.hsaReviewResize) this.hsaReviewResize.disconnect();
        if (this.hsaGalleryFrame != null) cancelAnimationFrame(this.hsaGalleryFrame);
        clearTimeout(this.hsaGalleryTimer);
        this.hsaGalleryFrame = null;
        if (this.hsaFrame != null) cancelAnimationFrame(this.hsaFrame);
        this.hsaController = null;
        this.hsaFrame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["happysoy-occasions"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('hs-category-discovery')) {
  customElements.define('hs-category-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const panels = Array.from(this.querySelectorAll('.hs-discover__panel'));
      if (!tabs.length || tabs.length !== panels.length) return;
      const activate = index => tabs.forEach((tab, n) => {
        tab.setAttribute('aria-selected', String(n === index));
        tab.tabIndex = n === index ? 0 : -1;
        panels[n].hidden = n !== index;
      });
      panels.forEach((panel, n) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabs[n].id);
      });
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(i));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(next); tabs[next].focus(); }
        });
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('.hs-discover__panel');
        const index = panels.indexOf(panel);
        if (index >= 0) activate(index);
      });
      activate(0);
      this.dataset.ready = 'true';
      this.querySelector('[role="tablist"]').hidden = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
